import { normalizeHotkey } from "@tanstack/react-hotkeys";
import type { HotkeyBindings } from "./hotkey-store";
import { resolveHotkey } from "./hotkey-store";
import { commands } from "./registry";

/**
 * Given a candidate chord and the command being edited, find the label of
 * whichever other command already owns that chord under the *effective*
 * bindings (a stored override, or an untouched default). Returns null when
 * there is no conflict.
 *
 * Chords are compared after `normalizeHotkey`, not by raw string equality:
 * the registry authors defaults like `Mod+Shift+P`, while the recorder emits
 * modifiers in the library's own order and swaps `Meta`→`Mod` on mac,
 * producing `Shift+Mod+P` for the same chord.
 */
export function findHotkeyConflict(chord: string | null, commandId: string, bindings: HotkeyBindings): string | null {
  if (!chord) return null;
  const normalizedChord = normalizeHotkey(chord);
  for (const cmd of commands) {
    if (cmd.id === commandId) continue;
    const effective = resolveHotkey(cmd.id, bindings);
    if (effective && normalizeHotkey(effective) === normalizedChord) return cmd.label;
  }
  return null;
}
